module.exports = __webpack_public_path__ + "img/header.75dea278.svg";